module.exports = __webpack_public_path__ + "1d9a8b457e9c0cb43876b33511838ba8.svg";